import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { 
        requestSaveOneClickSettings,
        requestSaveMobileStakesExchangeGameSettings,
        requestSaveMobileStakesSettings,
        requestSaveStakesSettings
      } from '../../../store/user/user.thunks';
import { setIsOpen } from '../../../store/editStakesPopUp/editStakesPopUp.slice';
import { requestStakeButtons, requestUpdateStakeButtons } from '../../../store/stakes/stakes.thunks';

export const connectEditStakesPopUp = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      user: state.user,
      balanceInformationHeight: state.balanceInformationHeight,
      isDetailedBalanceOpen: state.isDetailedBalanceOpen,
      stakes: state.stakes,
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      requestSaveOneClickSettings,
      requestSaveMobileStakesExchangeGameSettings,
      requestSaveMobileStakesSettings,
      requestSaveStakesSettings,
      setIsOpen,
      requestStakeButtons,
      requestUpdateStakeButtons
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
